import { injectable, inject } from 'inversify';
import dayjs from 'dayjs';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import { SectionCompletion } from '@/app/statistics/section/section-progress';
//import { InteractionCompletedEvent, InteractionCompletedEventName } from '../events/interaction-events';
import { createEvent } from '@/app/event-stream';
import { dispatchObjectCompletedEvent } from '@/app/statistics/utils/object-completion-utils';

@injectable()
export class SectionProgressUtils {

  @inject(EventStreamSymbol)
  private eventStream: EventStream;

  public setInteractionItemCompleted(
    completion: SectionCompletion,
    id: string,
    type: string,
    itemId: string|null = null,
    dispatchInteractionEvent: boolean = true
  ): SectionCompletion {
    completion.interactions.forEach((interaction) => {
      if (interaction.id === id) {
        let completed: boolean = true;
        if (itemId !== null) {
          interaction.items[itemId] = true;
          Object.values(interaction.items).forEach((value) => {
            if (!value) {
              completed = false;
            }
          });
        }

        if (completed) {
          if (dispatchInteractionEvent) {
            // TODO: result and durationSeconds params
            this.dispatchInteractionCompletedEvent(interaction.id, interaction.title, interaction.type, '', 'passed', 0);
          }

          dispatchObjectCompletedEvent(interaction.id);
        }

        interaction.completed = completed;
      }
    });

    return completion;
  }

  public createItemId(id: string, itemIndex: number): string {
    return `${id}-${itemIndex}`;
  }

  private dispatchInteractionCompletedEvent(
    id: string,
    title: string,
    type: string,
    response: string,
    result: 'passed' | 'failed' | 'neutral',
    durationSeconds: number
  ): void {
    // const payload: InteractionCompletedEvent = {
    //   id,
    //   title,
    //   type,
    //   response,
    //   result,
    //   durationSeconds,
    //   timestamp: dayjs().toDate()
    // };

    // const event = createEvent<typeof InteractionCompletedEventName, InteractionCompletedEvent>(
    //   InteractionCompletedEventName,
    //   payload
    // );

    // this.eventStream.dispatch(event);
  }
}

export const SectionProgressUtilsSymbol = Symbol.for('SectionProgressUtils');
